module.exports = __webpack_public_path__ + "static/media/Milex-Pessaries-Brochure@3x.de35a2b1.png";